// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/_rc-pagination@1.20.7@rc-pagination/assets/index.css
// module id = 722
// module chunks = 0